import LayoutDirectory from 'components/Content/ContentLayout/LayoutDirectory/LayoutDirectory';

export default LayoutDirectory;
